import React from 'react';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { finalCta } from '../data/content';
export function FinalCta() {
  return <section className="w-full border-t border-line bg-ink py-24 lg:py-28" data-id="element-49" data-mp="vh0q0fhsdpqd">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-50" data-mp="19fqmbsws7ldo">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-end" data-id="element-51" data-mp="15ddkvgp2i9mp">
          <div data-id="element-52" data-mp="15fq7461uz65k">
            <h2 className="display max-w-2xl text-[clamp(2.1rem,5vw,3.6rem)] leading-[0.96] text-cream" data-id="element-53" data-mp="1jcvatze3nsxn">
              {finalCta.heading}
            </h2>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-cream/70" data-id="element-54" data-mp="1edimtbbhsfth">{finalCta.body}</p>
          </div>
          <div className="flex flex-wrap items-center gap-4" data-id="element-55" data-mp="1t510h2gvpy9o">
            <a href="#tools" className="group inline-flex items-center gap-3 rounded-md bg-brand-green px-7 py-4 text-base font-semibold text-ink transition-colors duration-150 ease-out hover:bg-brand-greenDark hover:text-white" data-id="element-56" data-mp="1o4wkddjvv5jz">
              <MapPinIcon className="h-5 w-5" aria-hidden="true" data-id="element-57" data-mp="n64b3n7yhqle" />
              {finalCta.primary}
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-58" data-mp="s45t04tnbjva" />
            </a>
            <a href="#pricing" className="inline-flex items-center gap-2 rounded-md border border-line px-6 py-4 text-base font-semibold text-cream transition-colors duration-150 ease-out hover:border-cream/40 hover:bg-white/5" data-id="element-59" data-mp="123ek8px4mkdy">
              {finalCta.secondary}
            </a>
          </div>
        </div>
      </div>
    </section>;
}